import { ReactNode } from 'react';
import Option from '@/components/form/types/Option.ts';

/** Do `aria-live` i domyślnego filtrowania react-select — zawsze tekst. */
export const optionAriaLabel = (option: Option): string =>
  option.name ?? (typeof option.label === 'string' ? option.label : '');

/**
 * Bogatą etykietę rysuje `formatOptionLabel`, bo `getOptionLabel` jest już
 * zajęty przez tekst dla czytnika ekranu. Trafia ona do `children` opcji
 * i wybranej wartości, więc oba miejsca wyglądają tak samo jak wcześniej.
 */
export const renderOptionLabel = (option: Option): ReactNode => option.label;
